import {createStore} from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {staLogin} from './modules/staLogin'
import {staMenuList} from './modules/staMenuList'
import {staParam} from './modules/staParam'

export default createStore({
    modules: {
        staLogin,
        staMenuList,
        staParam
    },
    plugins: [
        createPersistedState({
            path: ['staLogin', 'staMenuList', 'staParam']
        })
    ]
})